import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/services/app.settings.service';
import { Observable } from 'rxjs';
import { BaseResultModel, SearchCriteriaModel, SearchResult } from 'app/models';
import { BankAccountSearchCriteriaModel } from '../models/bank-account-search-criteria.model';
import { BankAccountModel } from '../models/bank-account.model';
import { map } from 'rxjs/operators';
import { DropDownItem } from 'app/models/general/dropdownItem.model';

@Injectable()
export class BankAccountService {

    private readonly _apiUri: string;
    private readonly endpoint = '/api/bank-account';

    constructor(private http: HttpClient, configService: AppConfigService) {
        if (configService) {
            this._apiUri = configService.getAPIUrl();
        }
    }

    searchBankAccounts(model: SearchCriteriaModel<BankAccountSearchCriteriaModel>): Observable<BaseResultModel<SearchResult<BankAccountModel>>> {
        return this.http.post<BaseResultModel<SearchResult<BankAccountModel>>>(`${this._apiUri}${this.endpoint}/search`, model);
    }

    createBankAccount(request: { accountName: string; currencyId: number; bankName: string; accountNo?: string }): Observable<BaseResultModel<number>> {
        return this.http.post<BaseResultModel<number>>(`${this._apiUri}${this.endpoint}`, request);
    }

    updateBankAccount(id: number, request: { accountName: string; currencyId: number; bankName: string; accountNo?: string }): Observable<BaseResultModel<string>> {
        return this.http.put<BaseResultModel<string>>(`${this._apiUri}${this.endpoint}/${id}`, request);
    }

    deleteBankAccount(id: number): Observable<BaseResultModel<string>> {
        return this.http.delete<BaseResultModel<string>>(`${this._apiUri}${this.endpoint}/${id}`);
    }

    batchDeleteBankAccounts(ids: number[]): Observable<BaseResultModel<number>> {
        return this.http.post<BaseResultModel<number>>(`${this._apiUri}${this.endpoint}/batch-delete`, { ids });
    }

    getRefBankAccounts(): Observable<DropDownItem[]> {
        return this.http.get<BaseResultModel<DropDownItem[]>>(
            `${this._apiUri}${this.endpoint}/dropdown`
        ).pipe(map(response => response.status ? response.response : []));
    }
}
